import { invoiceNumber } from "./invoiceUtils";

export const invoiceYear = (invoice) => {
  const issuedYear = String(invoice?.issuedDate || "").slice(0, 4);
  if (/^\d{4}$/.test(issuedYear)) return issuedYear;
  return String(invoiceNumber(invoice)).match(/(?:^|\D)(20\d{2})(?:\D|$)/)?.[1] || "";
};

const invoiceSequence = (invoice) => {
  const value = String(invoiceNumber(invoice));
  const year = invoiceYear(invoice);
  const parts = value.match(/\d+/g)?.map(Number) || [];
  const sequence = parts.find((part) => String(part) !== year) ?? parts.at(-1) ?? 0;
  return { year: Number(year) || 0, sequence, value };
};

export const compareInvoices = (left, right, sort = "issued-desc") => {
  if (sort.startsWith("number")) {
    const leftNumber = invoiceSequence(left);
    const rightNumber = invoiceSequence(right);
    const direction = sort.endsWith("asc") ? 1 : -1;
    return direction * (
      leftNumber.year - rightNumber.year
      || leftNumber.sequence - rightNumber.sequence
      || leftNumber.value.localeCompare(rightNumber.value, undefined, { numeric: true })
    );
  }

  const direction = sort.endsWith("asc") ? 1 : -1;
  const leftDate = Date.parse(left?.issuedDate || "") || 0;
  const rightDate = Date.parse(right?.issuedDate || "") || 0;
  return direction * (leftDate - rightDate)
    || invoiceNumber(right).localeCompare(invoiceNumber(left), undefined, { numeric: true });
};

export const sortInvoices = (invoices = [], sort = "issued-desc") => [...invoices].sort((left, right) => compareInvoices(left, right, sort));

export const invoiceYears = (invoices = []) => [...new Set(invoices.map(invoiceYear).filter(Boolean))].sort().reverse();

export const latestInvoiceDateForClient = (client, invoices = []) => invoices.reduce((latest, invoice) => {
  const matches = invoice.clientId ? invoice.clientId === client.id : invoice.client === client.name;
  if (!matches) return latest;
  const date = String(invoice.issuedDate || "");
  return date > latest ? date : latest;
}, String(client?.lastInvoiceIssuedOn || "").slice(0, 10));

export const sortClientsByInvoiceRecency = (clients = [], invoices = []) => [...clients].sort((left, right) => {
  const rightDate = latestInvoiceDateForClient(right, invoices);
  const leftDate = latestInvoiceDateForClient(left, invoices);
  return rightDate.localeCompare(leftDate) || String(left.name).localeCompare(String(right.name));
});
